function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import Url from 'url-parse';
/**
 * Gets the valid
 * @param {boolean} [includeNonStandard]
 * @returns {{key: string, value: string}[]}
 */

export function getPageUtms(includeNonStandard) {
  var validUtms = ['source', 'campaign', 'medium', 'content', 'term'];
  var nonStandardUtms = ['offer'];
  var pageUrl = new Url(window.location.href, true);
  return Object.entries(pageUrl.query).filter(function (entry) {
    return entry[0].toLowerCase().startsWith('utm_') && (validUtms.includes(entry[0].substring(4).toLowerCase()) || includeNonStandard && nonStandardUtms.includes(entry[0].substring(4).toLowerCase()));
  }).map(function (entry) {
    return {
      key: entry[0],
      value: entry[1]
    };
  });
}
export function prefixedLogger(prefix) {
  var logMethod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : console.debug;
  return function (msg) {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    return logMethod.call.apply(logMethod, [logMethod, "".concat(prefix, " ").concat(msg)].concat(rest));
  };
}
/**
 * Yields to the main thread to prevent blocking the UI
 * @returns {Promise<unknown>}
 * @see https://www.corewebvitals.io/pagespeed/yield-to-main-thread
 */

export function yieldToMain() {
  return _yieldToMain.apply(this, arguments);
}

function _yieldToMain() {
  _yieldToMain = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!('scheduler' in window && 'yield' in window.scheduler)) {
              _context.next = 4;
              break;
            }

            _context.next = 3;
            return window.scheduler["yield"]();

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
            return _context.abrupt("return", new Promise(function (resolve) {
              setTimeout(resolve, 0);
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _yieldToMain.apply(this, arguments);
}